import React, { Suspense } from "react";
import { BrowserRouter, Route, Switch, Redirect } from "react-router-dom";
import { RoutesMapper, role, devportal, qaportal } from "../util/navigationBuilders";
import { ErrorBoundary } from "react-error-boundary";
import ErrorFallback from "./ErrorFallback";
const Layout = React.lazy(() => import("./Layout"));

export default class Routes extends React.Component {
    render() {
        const derivedProps = { role, devportal, qaportal },
            offlineSync = this.props.offlineSync;
        return (
            <BrowserRouter>
                <ErrorBoundary FallbackComponent={ErrorFallback}>
                    <Switch>
                        {RoutesMapper.map((route, i) => (
                            <Route
                                key={i}
                                path={route.path}
                                exact={route.exact ? !!route.exact : false}
                                render={(props) => {
                                    props = { ...props, ...derivedProps, offlineSync };
                                    return (
                                        <Suspense fallback={<route.loader />}>
                                            {route.layout ? (
                                                <Layout {...props}>
                                                    <route.Component {...props} />
                                                </Layout>
                                            ) : (
                                                <route.Component {...props} />
                                            )}
                                        </Suspense>
                                    );
                                }}
                            />
                        ))}
                        <Redirect to="/dashboard" />
                    </Switch>
                </ErrorBoundary>
            </BrowserRouter>
        );
    }
}
